// extracted by mini-css-extract-plugin
export var container = "styles-module__container___Y2byE";
export var hero = "styles-module__hero___e8m_L";
export var innerContainer = "styles-module__innerContainer___TsKaF";
export var headerText = "styles-module__headerText___VjuD0";
export var headerSubtext = "styles-module__headerSubtext___IF7O5";
export var largeArrow = "styles-module__largeArrow___s8B7R";